import { render, staticRenderFns } from "./AgentInfo.vue?vue&type=template&id=08fa8e31&scoped=true&"
import script from "./AgentInfo.vue?vue&type=script&lang=js&"
export * from "./AgentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa8e31",
  null
  
)

export default component.exports